import { useMemo } from 'react';
import { Radio, Select, Space } from 'antd';
import { useAppDispatch, useAppState } from '../../store/hooks';
import type { RecordRange, SortDirection } from '../../api/types';
import { RANGE_LABELS } from '../../utils/constants';
import styles from './styles.module.css';

export function RangePanel() {
  const { range, sort, fieldOptions } = useAppState();
  const dispatch = useAppDispatch();

  const fieldOpts = useMemo(
    () =>
      [...fieldOptions]
        .sort((a, b) => a.order - b.order)
        .map((f) => ({ value: f.id, label: f.name })),
    [fieldOptions],
  );

  return (
    <div className={styles.panel}>
      <div className={styles.row}>
        {/* 下面两行都有前置标签，这行原来没有，三行左边缘对不齐 */}
        <span className={styles.label}>记录范围</span>
        <Radio.Group
          size="small"
          value={range}
          onChange={(e) =>
            dispatch({ type: 'SET_RANGE', range: e.target.value as RecordRange })
          }
        >
          <Radio.Button value="visible">{RANGE_LABELS.visible}</Radio.Button>
          <Radio.Button value="selected">{RANGE_LABELS.selected}</Radio.Button>
          <Radio.Button value="all">{RANGE_LABELS.all}</Radio.Button>
        </Radio.Group>
      </div>

      <div className={styles.row}>
        <span className={styles.label}>排序字段</span>
        <Select
          size="small"
          className={styles.fill}
          placeholder="按记录原始顺序"
          allowClear
          value={sort.fieldId ?? undefined}
          options={fieldOpts}
          onChange={(value) =>
            dispatch({
              type: 'SET_SORT',
              sort: { fieldId: value ?? null, direction: sort.direction },
            })
          }
          disabled={fieldOpts.length === 0}
        />
      </div>

      <div className={styles.row}>
        <span className={styles.label}>排序方向</span>
        <Space size={4}>
          <Radio.Group
            size="small"
            value={sort.direction}
            disabled={!sort.fieldId}
            onChange={(e) =>
              dispatch({
                type: 'SET_SORT',
                sort: { fieldId: sort.fieldId, direction: e.target.value as SortDirection },
              })
            }
          >
            <Radio.Button value="asc">升序</Radio.Button>
            <Radio.Button value="desc">降序</Radio.Button>
          </Radio.Group>
        </Space>
      </div>
    </div>
  );
}
